import { notesReqApprovalActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [notesReqApprovalActions.loadSuccess]: (state, action) => {
        return action.payload.entities.notesReqApprovalMsgs;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let result;
        action.payload.notesRequiringApproval.entities.notesReqApprovalMsgs ? result = action.payload.notesRequiringApproval.entities.notesReqApprovalMsgs : result = {};
        return result;
    },
})


